import React, { Component } from "react";
import { authStoreSelectors } from "../../../store/store";
import { AuthActionCreators } from "../../../actions/actionCreators";
import { connect } from "react-redux";
import { ActionCreator } from "../../../../../actions/actions";
import { Route } from "../../../../../api/apiTypes";
import { skeletonStoreSelectors } from "../../../../../store";
import Drawer from "../../../../../utils/Drawer/Drawer.component";
import RoleCreationPage from "../RoleCreation/RoleCreationPage.component";
import RoleCard from "./RoleCard/RoleCard.component";
import "./RolesListPage.component.scss";
import { Dialog } from "../../../../../utils/Dialog/Dialog.component";
import { checkAuthorization } from "../../../../../utils/Authorization/authorization";
import { AuthAPIRoutes } from "../../../api/auth.apiRoutes";
import Paginator from "../../../../../utils/Paginator/Paginator.component";
import { User } from "../../../reducers/users.reducer";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";
import {cloneDeep} from "lodash";

export interface Role {
    id: number;
    name: string;
    permission_spec: any;
    editable: boolean;
    in: any;
    created: string;
    updated: string;
    users: User[];
    subsidiary: number;
}

export enum ROLE_ACTIONS {
    ADD_ROLE = "ADD_ROLE",
    EDIT_ROLE = "EDIT_ROLE",
    DETAILS_ROLE = "DETAILS_ROLE",
    DELETE_ROLE = "DELETE_ROLE"
}

export interface RolesListProps {
    getUsers: ActionCreator;
    users_dict: {
        number_of_total_users: number;
        users: User[];
    };
    apiRoutes: Route[];
    getRoles: ActionCreator;
    roles_dict: {
        total_number_of_roles: number;
        roles_array: Role[];
    };
    rolesLoading: boolean;
    deleteRole: ActionCreator;
    getSubsidiaries: ActionCreator;
    subsidiariesLoading: boolean;
    openDrawerRole: ActionCreator;
    createRole: ActionCreator;
    editRole: ActionCreator;
    shouldCloseDrawer: boolean;
}

export interface RolesListState {
    open_popup: boolean;
    drawer_values: {
        drawer_title: string;
        role_obj: Role;
        role_action: string;
        form_button_name?: string;
        show_search_results_area?: boolean;
        search_term?: string;
        current_role_routes_obj?: any;
    };
    open_dialog: boolean;
    dialog_values: {
        dialog_message: string;
        role_action: string;
        role_id: [];
        user_id?: number;
    };
    current_page: number;
    total_roles_by_page: number;
    roles_dict: {
        total_number_of_roles: number;
        roles_array: [];
    };
    roles_dict_orig: {
        total_number_of_roles: number;
        roles_array: [];
    };
}

class RolesList extends Component<RolesListProps, RolesListState> {
    constructor(props) {
        super(props);
        this.state = {
            open_popup: false,
            drawer_values: {
                drawer_title: "",
                role_obj: null,
                role_action: "",
                form_button_name: "",
                search_term: "",
                show_search_results_area: false,
                current_role_routes_obj: []
            },
            open_dialog: false,
            dialog_values: {
                dialog_message: "",
                role_action: "",
                role_id: null,
                user_id: null
            },
            current_page: 1,
            total_roles_by_page: 100,
            roles_dict: {
                total_number_of_roles: 0,
                roles_array: []
            },
            roles_dict_orig: {
                total_number_of_roles: 0,
                roles_array: []
            }
        };
        this.openPopUp = this.openPopUp.bind(this);
        this.closePopUp = this.closePopUp.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.handleInputTextSearch = this.handleInputTextSearch.bind(this);
        this.handleConfirmedDeleteOption =
            this.handleConfirmedDeleteOption.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.props.getSubsidiaries();
    }

    componentDidMount() {
        this.props.getRoles({
            current_page: this.state.current_page,
            total_roles_by_page: this.state.total_roles_by_page
        });





        /*
        let uniq_1 = [
                {
                    "id": 8,
                    "name": "Activate/Deactivate Halls MX ES US",
                    "editable": true,
                    "created_on": "2023-06-26T15:09:51",
                    "access": [
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": true,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 39,
                            "resource_entity": {
                                "name": "hall",
                                "description": "Hall",
                                "id": 4,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 40,
                            "resource_entity": {
                                "name": "hall_license_renew",
                                "description": "Hall License Renew",
                                "id": 5,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 41,
                            "resource_entity": {
                                "name": "server",
                                "description": "Server",
                                "id": 6,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 42,
                            "resource_entity": {
                                "name": "subsidiary",
                                "description": "Subsidiary",
                                "id": 10,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 43,
                            "resource_entity": {
                                "name": "license",
                                "description": "License",
                                "id": 25,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": true,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": true,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": true,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 44,
                            "resource_entity": {
                                "name": "server_license_state",
                                "description": "Server License State",
                                "id": 55,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": false,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        }
                    ],
                    "subsidiary": {
                        "id": 1,
                        "logo": "",
                        "dynamics_name": "FBM MEX",
                        "name": null,
                        "description": "FBM-MX",
                        "country": {
                            "id": 1,
                            "name": "Mexico",
                            "code": "MX"
                        },
                        "company": {
                            "name": "FBM Gaming",
                            "short_name": "FBM",
                            "country_id": 2,
                            "id": 1
                        }
                    }
                },
                {
                    "id": 9,
                    "name": "Activate/Deactivate Halls MX ES US",
                    "editable": true,
                    "created_on": "2023-06-26T15:09:51",
                    "access": [
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": true,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 45,
                            "resource_entity": {
                                "name": "hall",
                                "description": "Hall",
                                "id": 4,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 46,
                            "resource_entity": {
                                "name": "hall_license_renew",
                                "description": "Hall License Renew",
                                "id": 5,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 47,
                            "resource_entity": {
                                "name": "server",
                                "description": "Server",
                                "id": 6,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 48,
                            "resource_entity": {
                                "name": "subsidiary",
                                "description": "Subsidiary",
                                "id": 10,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 49,
                            "resource_entity": {
                                "name": "license",
                                "description": "License",
                                "id": 25,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": true,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": true,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": true,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 50,
                            "resource_entity": {
                                "name": "server_license_state",
                                "description": "Server License State",
                                "id": 55,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": false,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        }
                    ],
                    "subsidiary": {
                        "id": 3,
                        "logo": "",
                        "dynamics_name": "EPS ESP",
                        "name": null,
                        "description": "FBM-ES",
                        "country": {
                            "id": 3,
                            "name": "Spain",
                            "code": "ES"
                        },
                        "company": {
                            "name": "FBM Gaming",
                            "short_name": "FBM",
                            "country_id": 2,
                            "id": 1
                        }
                    }
                },
                {
                    "id": 10,
                    "name": "Activate/Deactivate Halls MX ES US",
                    "editable": true,
                    "created_on": "2023-06-26T15:09:51",
                    "access": [
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": true,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 51,
                            "resource_entity": {
                                "name": "hall",
                                "description": "Hall",
                                "id": 4,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 52,
                            "resource_entity": {
                                "name": "hall_license_renew",
                                "description": "Hall License Renew",
                                "id": 5,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 53,
                            "resource_entity": {
                                "name": "server",
                                "description": "Server",
                                "id": 6,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 54,
                            "resource_entity": {
                                "name": "subsidiary",
                                "description": "Subsidiary",
                                "id": 10,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 55,
                            "resource_entity": {
                                "name": "license",
                                "description": "License",
                                "id": 25,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": true,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": true,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": true,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 56,
                            "resource_entity": {
                                "name": "server_license_state",
                                "description": "Server License State",
                                "id": 55,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": false,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        }
                    ],
                    "subsidiary": {
                        "id": 9,
                        "logo": "",
                        "dynamics_name": "FGA USA",
                        "name": null,
                        "description": "FBM-US",
                        "country": {
                            "id": 8,
                            "name": "United States of America",
                            "code": "US"
                        },
                        "company": {
                            "name": "FBM Gaming",
                            "short_name": "FBM",
                            "country_id": 2,
                            "id": 1
                        }
                    }
                },
                {
                    "id": 4,
                    "name": "List Halls ES US",
                    "editable": true,
                    "created_on": "2023-06-26T11:20:03",
                    "access": [
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 13,
                            "resource_entity": {
                                "name": "hall",
                                "description": "Hall",
                                "id": 4,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 14,
                            "resource_entity": {
                                "name": "hall_license_renew",
                                "description": "Hall License Renew",
                                "id": 5,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 15,
                            "resource_entity": {
                                "name": "server",
                                "description": "Server",
                                "id": 6,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 16,
                            "resource_entity": {
                                "name": "subsidiary",
                                "description": "Subsidiary",
                                "id": 10,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 17,
                            "resource_entity": {
                                "name": "license",
                                "description": "License",
                                "id": 25,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": true,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": true,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": true,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 18,
                            "resource_entity": {
                                "name": "server_license_state",
                                "description": "Server License State",
                                "id": 55,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": false,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        }
                    ],
                    "subsidiary": {
                        "id": 3,
                        "logo": "",
                        "dynamics_name": "EPS ESP",
                        "name": null,
                        "description": "FBM-ES",
                        "country": {
                            "id": 3,
                            "name": "Spain",
                            "code": "ES"
                        },
                        "company": {
                            "name": "FBM Gaming",
                            "short_name": "FBM",
                            "country_id": 2,
                            "id": 1
                        }
                    }
                },
                {
                    "id": 5,
                    "name": "List Halls ES US",
                    "editable": true,
                    "created_on": "2023-06-26T11:20:03",
                    "access": [
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 19,
                            "resource_entity": {
                                "name": "hall",
                                "description": "Hall",
                                "id": 4,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 20,
                            "resource_entity": {
                                "name": "hall_license_renew",
                                "description": "Hall License Renew",
                                "id": 5,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 21,
                            "resource_entity": {
                                "name": "server",
                                "description": "Server",
                                "id": 6,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 22,
                            "resource_entity": {
                                "name": "subsidiary",
                                "description": "Subsidiary",
                                "id": 10,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 23,
                            "resource_entity": {
                                "name": "license",
                                "description": "License",
                                "id": 25,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": true,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": true,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": true,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 24,
                            "resource_entity": {
                                "name": "server_license_state",
                                "description": "Server License State",
                                "id": 55,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": false,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        }
                    ],
                    "subsidiary": {
                        "id": 9,
                        "logo": "",
                        "dynamics_name": "FGA USA",
                        "name": null,
                        "description": "FBM-US",
                        "country": {
                            "id": 8,
                            "name": "United States of America",
                            "code": "US"
                        },
                        "company": {
                            "name": "FBM Gaming",
                            "short_name": "FBM",
                            "country_id": 2,
                            "id": 1
                        }
                    }
                },
                {
                    "id": 2,
                    "name": "List Servers MX ES",
                    "editable": false,
                    "created_on": "2023-06-26T11:20:03",
                    "access": [
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 1,
                            "resource_entity": {
                                "name": "hall",
                                "description": "Hall",
                                "id": 4,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 2,
                            "resource_entity": {
                                "name": "hall_license_renew",
                                "description": "Hall License Renew",
                                "id": 5,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 3,
                            "resource_entity": {
                                "name": "server",
                                "description": "Server",
                                "id": 6,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 4,
                            "resource_entity": {
                                "name": "subsidiary",
                                "description": "Subsidiary",
                                "id": 10,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 5,
                            "resource_entity": {
                                "name": "license",
                                "description": "License",
                                "id": 25,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": true,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": true,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": true,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 6,
                            "resource_entity": {
                                "name": "server_license_state",
                                "description": "Server License State",
                                "id": 55,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": false,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        }
                    ],
                    "subsidiary": {
                        "id": 1,
                        "logo": "",
                        "dynamics_name": "FBM MEX",
                        "name": null,
                        "description": "FBM-MX",
                        "country": {
                            "id": 1,
                            "name": "Mexico",
                            "code": "MX"
                        },
                        "company": {
                            "name": "FBM Gaming",
                            "short_name": "FBM",
                            "country_id": 2,
                            "id": 1
                        }
                    }
                },
                {
                    "id": 3,
                    "name": "List Servers MX ES",
                    "editable": false,
                    "created_on": "2023-06-26T11:20:03",
                    "access": [
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 7,
                            "resource_entity": {
                                "name": "hall",
                                "description": "Hall",
                                "id": 4,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 8,
                            "resource_entity": {
                                "name": "hall_license_renew",
                                "description": "Hall License Renew",
                                "id": 5,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 9,
                            "resource_entity": {
                                "name": "server",
                                "description": "Server",
                                "id": 6,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 10,
                            "resource_entity": {
                                "name": "subsidiary",
                                "description": "Subsidiary",
                                "id": 10,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 11,
                            "resource_entity": {
                                "name": "license",
                                "description": "License",
                                "id": 25,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": true,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": true,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": true,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 12,
                            "resource_entity": {
                                "name": "server_license_state",
                                "description": "Server License State",
                                "id": 55,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": false,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        }
                    ],
                    "subsidiary": {
                        "id": 3,
                        "logo": "",
                        "dynamics_name": "EPS ESP",
                        "name": null,
                        "description": "FBM-ES",
                        "country": {
                            "id": 3,
                            "name": "Spain",
                            "code": "ES"
                        },
                        "company": {
                            "name": "FBM Gaming",
                            "short_name": "FBM",
                            "country_id": 2,
                            "id": 1
                        }
                    }
                },
                {
                    "id": 6,
                    "name": "Manage Halls ES PT",
                    "editable": true,
                    "created_on": "2023-06-26T11:26:44",
                    "access": [
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": true,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": true,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 25,
                            "resource_entity": {
                                "name": "hall",
                                "description": "Hall",
                                "id": 4,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 26,
                            "resource_entity": {
                                "name": "hall_license_renew",
                                "description": "Hall License Renew",
                                "id": 5,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 27,
                            "resource_entity": {
                                "name": "server",
                                "description": "Server",
                                "id": 6,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 28,
                            "resource_entity": {
                                "name": "subsidiary",
                                "description": "Subsidiary",
                                "id": 10,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 29,
                            "resource_entity": {
                                "name": "license",
                                "description": "License",
                                "id": 25,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": true,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": true,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": true,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 30,
                            "resource_entity": {
                                "name": "server_license_state",
                                "description": "Server License State",
                                "id": 55,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": false,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 31,
                            "resource_entity": {
                                "name": "country_timezone",
                                "description": "Country Timezone",
                                "id": 11,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": false,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        }
                    ],
                    "subsidiary": {
                        "id": 3,
                        "logo": "",
                        "dynamics_name": "EPS ESP",
                        "name": null,
                        "description": "FBM-ES",
                        "country": {
                            "id": 3,
                            "name": "Spain",
                            "code": "ES"
                        },
                        "company": {
                            "name": "FBM Gaming",
                            "short_name": "FBM",
                            "country_id": 2,
                            "id": 1
                        }
                    }
                },
                {
                    "id": 7,
                    "name": "Manage Halls ES PT",
                    "editable": true,
                    "created_on": "2023-06-26T11:26:44",
                    "access": [
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": true,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": true,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 32,
                            "resource_entity": {
                                "name": "hall",
                                "description": "Hall",
                                "id": 4,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 33,
                            "resource_entity": {
                                "name": "hall_license_renew",
                                "description": "Hall License Renew",
                                "id": 5,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 34,
                            "resource_entity": {
                                "name": "server",
                                "description": "Server",
                                "id": 6,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": true,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": true,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 35,
                            "resource_entity": {
                                "name": "subsidiary",
                                "description": "Subsidiary",
                                "id": 10,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 36,
                            "resource_entity": {
                                "name": "license",
                                "description": "License",
                                "id": 25,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": true,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": true,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": true,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": true,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": true,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 37,
                            "resource_entity": {
                                "name": "server_license_state",
                                "description": "Server License State",
                                "id": 55,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": false,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        },
                        {
                            "access": {
                                "read": {
                                    "allow": true,
                                    "val": "0b1"
                                },
                                "add": {
                                    "allow": false,
                                    "val": "0b10"
                                },
                                "edit": {
                                    "allow": false,
                                    "val": "0b100"
                                },
                                "delete": {
                                    "allow": false,
                                    "val": "0b1000"
                                },
                                "approve": {
                                    "allow": false,
                                    "val": "0b10000"
                                },
                                "activate": {
                                    "allow": false,
                                    "val": "0b100000"
                                },
                                "cancel": {
                                    "allow": false,
                                    "val": "0b1000000"
                                },
                                "renew": {
                                    "allow": false,
                                    "val": "0b10000000"
                                }
                            },
                            "id": 38,
                            "resource_entity": {
                                "name": "country_timezone",
                                "description": "Country Timezone",
                                "id": 11,
                                "allowed_access": {
                                    "read": {
                                        "allow": true,
                                        "val": "0b1"
                                    },
                                    "add": {
                                        "allow": false,
                                        "val": "0b10"
                                    },
                                    "edit": {
                                        "allow": false,
                                        "val": "0b100"
                                    },
                                    "delete": {
                                        "allow": false,
                                        "val": "0b1000"
                                    },
                                    "approve": {
                                        "allow": false,
                                        "val": "0b10000"
                                    },
                                    "activate": {
                                        "allow": false,
                                        "val": "0b100000"
                                    },
                                    "cancel": {
                                        "allow": false,
                                        "val": "0b1000000"
                                    },
                                    "renew": {
                                        "allow": false,
                                        "val": "0b10000000"
                                    }
                                }
                            }
                        }
                    ],
                    "subsidiary": {
                        "id": 7,
                        "logo": null,
                        "dynamics_name": "FBM PT",
                        "name": null,
                        "description": "FBM-PT",
                        "country": {
                            "id": 6,
                            "name": "Portugal",
                            "code": "PT"
                        },
                        "company": {
                            "name": "FBM Gaming",
                            "short_name": "FBM",
                            "country_id": 2,
                            "id": 1
                        }
                    }
                }
            ]

        let concatActiveRoutes = cloneDeep(uniq_1);

        uniq_1.filter((obj, index) => {
            let find_index = uniq_1.findIndex(o => obj.name === o.name && JSON.stringify(this.orderByKey(obj.access)) === JSON.stringify(this.orderByKey(o.access)));



            if (index !== find_index) {

                if ('in' in concatActiveRoutes[find_index]) {
                    concatActiveRoutes[find_index].in = concatActiveRoutes[find_index].in.concat([{
                        id: obj.id,
                        subsidiary: obj.subsidiary.id
                    }])

                } else {
                    concatActiveRoutes[find_index].in = [{
                        id: concatActiveRoutes[find_index].id,
                        subsidiary: concatActiveRoutes[find_index].subsidiary.id
                    }].concat([{
                        id: obj.id,
                        subsidiary: obj.subsidiary.id
                    }]);
                }


                delete concatActiveRoutes[index];
            }


        });

        concatActiveRoutes.map(role => {
            role.access.map(a => {
                a.id = a.resource_entity.id;
                delete a.resource_entity
            })
            delete role.id;
            delete role.subsidiary;
        })



        console.log('***concatActiveRoutes', concatActiveRoutes);
        */


    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.shouldCloseDrawer == false &&
            this.props.shouldCloseDrawer == true
        ) {
            this.closePopUp();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.roles_dict.roles_array &&
            (nextProps.roles_dict.total_number_of_roles !== this.state.roles_dict_orig.total_number_of_roles ||
                JSON.stringify(this.orderByKey(nextProps.roles_dict.roles_array)) !== JSON.stringify(this.orderByKey(this.state.roles_dict_orig.roles_array)))) {
            let _roles_array = cloneDeep(nextProps.roles_dict.roles_array);
            nextProps.roles_dict.roles_array.filter((obj, index) => {
                let find_index = nextProps.roles_dict.roles_array.findIndex(o => obj.name === o.name && JSON.stringify(this.orderByKey(obj.access)) === JSON.stringify(this.orderByKey(o.access)));

                if (index !== find_index) {
                    if ('in' in _roles_array[find_index]) {
                        _roles_array[find_index].in = _roles_array[find_index].in.concat([{
                            id: obj.id,
                            subsidiary: obj.subsidiary.id
                        }])

                    } else {
                        _roles_array[find_index].in = [{
                            id: _roles_array[find_index].id,
                            subsidiary: _roles_array[find_index].subsidiary ? _roles_array[find_index].subsidiary.id : _roles_array[find_index].subsidiary
                        }].concat([{
                            id: obj.id,
                            subsidiary: obj.subsidiary.id
                        }]);
                    }
                    delete _roles_array[index];
                } else {
                    _roles_array[find_index].in = [{
                        id: _roles_array[find_index].id,
                        subsidiary: _roles_array[find_index].subsidiary ? _roles_array[find_index].subsidiary.id : _roles_array[find_index].subsidiary
                    }]
                }
            });
            _roles_array.map(role => {
                role.access.map(a => {
                    a.id = a.resource_entity.id;
                    a.name = a.resource_entity.name
                    delete a.resource_entity
                });
                delete role.id;
                delete role.subsidiary;
            })

            this.setState({
                roles_dict: {
                    total_number_of_roles: _roles_array.length,
                    roles_array: _roles_array.filter(role => role)
                },
                roles_dict_orig: {
                    total_number_of_roles: nextProps.roles_dict.total_number_of_roles,
                    roles_array: nextProps.roles_dict.roles_array
                }
            });

        }
    }

    orderByKey = (dict) => {
        let obj = {};
        let keys = Object.keys(dict).sort();

        keys.forEach(k => {
            if(k=="id" || k=="resource_entity"){
                //delete dict[k]
            }else {
                if (dict[k] && typeof (dict[k]) == 'object') {
                    obj[k] = this.orderByKey(dict[k]);
                } else obj[k] = dict[k];
            }
        });

        return obj;
    }

    handleInputTextSearch(e) {
        let drawer_values_copy = { ...this.state.drawer_values };
        let can_show_results_area = false;
        if (e.currentTarget.value.trim() !== "") {
            can_show_results_area = true;
        }
        drawer_values_copy["show_search_results_area"] = can_show_results_area;
        drawer_values_copy["search_term"] = e.currentTarget.value;
        const role_filter_json_obj = {
            role_comparison_operator: "ne",
            role_ids_array: [this.state.drawer_values.role_obj.id]
        };
        this.setState({ drawer_values: drawer_values_copy });
        this.props.getUsers({
            search_term: drawer_values_copy["search_term"],
            roles: role_filter_json_obj
        });
    }

    handleConfirmedDeleteOption() {
        if (this.state.dialog_values.role_action === ROLE_ACTIONS.DELETE_ROLE) {
            this.state.dialog_values.role_id.map(id =>{
                this.props.deleteRole({
                    role_id: id,
                    current_page: this.state.current_page,
                    total_roles_by_page: this.state.total_roles_by_page
                });
            })

        }
        this.setState({ open_dialog: false });
    }

    openPopUp(event, drawer_values) {
        this.setState({ open_popup: false }, () =>
            this.setState({ open_popup: true, drawer_values: drawer_values })
        );
        this.props.openDrawerRole();
    }

    closePopUp() {
        this.setState({
            open_popup: false,
            drawer_values: {
                drawer_title: "",
                role_obj: null,
                form_button_name: "",
                role_action: "",
                search_term: "",
                show_search_results_area: false
            }
        });
    }

    openDialog(event, dialog_values) {
        this.setState({ open_dialog: false }, () =>
            this.setState({ open_dialog: true, dialog_values: dialog_values })
        );
    }

    closeDialog() {
        this.setState({
            open_dialog: false,
            dialog_values: {
                dialog_message: "",
                role_action: "",
                role_id: null,
                user_id: null
            }
        });
    }

    onPageChange(page_number) {
        this.setState({ current_page: page_number }, () =>
            this.props.getRoles({
                current_page: this.state.current_page,
                total_roles_by_page: this.state.total_roles_by_page
            })
        );
    }

    renderContent = () => {
        return (
            <div className="users-content">
                {checkAuthorization({
                    route: AuthAPIRoutes.GET_ROLES
                }) &&
                    this.state.roles_dict.total_number_of_roles > 0 &&
                    this.state.roles_dict.roles_array.map((role_json,index) => (
                        <RoleCard
                            key={index}
                            role_obj={role_json}
                            open_popup={this.openPopUp}
                            open_dialog={this.openDialog}
                        />
                    ))}
            </div>
        );
    };

    createRole = json => {
        this.props.createRole({
            role_info: json,
            current_page: this.state.current_page,
            total_roles_by_page: this.state.total_roles_by_page
        });
    };

    editRole = (id, json) => {
        this.props.editRole({
            role_id: id,
            role_info: json,
            current_page: this.state.current_page,
            total_roles_by_page: this.state.total_roles_by_page
        });
    };

    render() {
        return (
            <div id="UsersList" className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-6">
                            <h2 className="section-title">Roles Management</h2>
                        </div>

                        <div className="col-6 center-vertical buttons-col">
                            {checkAuthorization({
                                route: AuthAPIRoutes.CREATE_ROLE
                            }) && (
                                <button
                                    className="new-user red-btn"
                                    onClick={e =>
                                        this.openPopUp(e, {
                                            drawer_title: "New Role",
                                            form_button_name: "Create",
                                            role_action: ROLE_ACTIONS.ADD_ROLE,
                                            role_obj: { id: "", name: "", in: [] }
                                        })
                                    }
                                >
                                    <span>New Role</span>
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="row content body">
                        {(this.props.subsidiariesLoading ||
                            this.props.rolesLoading) && (
                            <div className="loading" key="loading">
                                <Components.LoadingRipple
                                    width={100}
                                    height={100}
                                />
                            </div>
                        )}
                        {!this.props.subsidiariesLoading &&
                            !this.props.rolesLoading &&
                            this.renderContent()}
                    </div>

                    <Dialog
                        open={this.state.open_dialog}
                        onConfirm={this.handleConfirmedDeleteOption}
                        onClose={this.closeDialog}
                    >
                        {this.state.dialog_values.dialog_message}
                    </Dialog>

                    {this.state.open_popup && (
                        <Drawer
                            title={this.state.drawer_values.drawer_title}
                            onClose={this.closePopUp}
                        >
                                <RoleCreationPage
                                    drawerValues={this.state.drawer_values}
                                    createRole={this.createRole}
                                    editRole={this.editRole}
                                />
                        </Drawer>
                    )}
                </div>
                <div className="row users-pagination container">
                    <div className="col-12 center-vertical paginator">
                        {this.props.roles_dict.total_number_of_roles > 0 && (
                            <Paginator
                                currentPage={this.state.current_page}
                                totalPages={Math.ceil(
                                    this.props.roles_dict
                                        .total_number_of_roles /
                                        this.state.total_roles_by_page
                                )}
                                onPageChange={this.onPageChange}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    users_dict: authStoreSelectors.users_dict(state),
    apiRoutes: skeletonStoreSelectors.apiRoutes(),
    roles_dict: authStoreSelectors.roles_dict(state),
    rolesLoading: authStoreSelectors.rolesLoading(state),
    subsidiariesLoading: authStoreSelectors.subsidiariesLoading(state),
    shouldCloseDrawer: authStoreSelectors.shouldCloseDrawer(state)
});

const mapDispatchToProps = {
    getRoles: AuthActionCreators.getRoles,
    getUsers: AuthActionCreators.getUsers,
    deleteRole: AuthActionCreators.deleteRole,
    getSubsidiaries: AuthActionCreators.getSubsidiaries,
    openDrawerRole: AuthActionCreators.openDrawerRole,
    createRole: AuthActionCreators.createRole,
    editRole: AuthActionCreators.editRole
};

export default connect(mapStateToProps, mapDispatchToProps)(RolesList);
